import findLastIndex from 'lodash/findLastIndex';

import type { Drawer, FlatDrawers } from '@virtuslab/nfs-shared/src/schema/user/drawerModels';
import type { Nullable } from '@virtuslab/nfs-shared/src/services/object';

import { toTree } from '..';

const queryResolver = (
  drawers: FlatDrawers,
): Nullable<Drawer> => {
  const drawerIndex = findLastIndex(drawers, { visible: true });

  if (drawerIndex === -1) {
    return null;
  }

  return toTree(drawers.slice(drawerIndex));
};

export default queryResolver;
